module.exports = __webpack_public_path__ + "static/paleosite_morphing2-0b1d40eebbf350b52f6c9be55671e424.png";